import React, { useState } from 'react';
import '../styles/Leaderboard.css';
import { convertCountryCodeToName } from '../utils/countryUtils';

function Leaderboard({ countryScores }) {
  const [isVisible, setIsVisible] = useState(false);

  const sortedCountries = Object.entries(countryScores || {})
    .filter(([country, score]) => country !== 'Unknown')
    .map(([country, score]) => ({
      country: convertCountryCodeToName(country),
      score: typeof score === 'number' ? score : 0
    }))
    .sort((a, b) => b.score - a.score);

  const formatNumber = (num) => {
    return num.toLocaleString('en-US');
  };

  return (
    <div className={`leaderboard ${isVisible ? 'visible' : ''}`}>
      <button 
        className="leaderboard-button"
        onClick={() => setIsVisible(!isVisible)}
      >
        {isVisible ? 'HIDE' : 'SHOW'} GLOBAL SENTIMENT
      </button>
      {isVisible && (
        <div className="leaderboard-content">
          <h2>Global AI Sentiment</h2>
          <div className="countries-list">
            {sortedCountries.map((country, index) => (
              <div key={country.country} className="country-row">
                <span className="rank">{index + 1}</span>
                <span className="country">{country.country}</span>
                <span className="score" style={{ color: country.score >= 0 ? '#00cc00' : '#ff4444' }}>
                  {formatNumber(country.score)}
                </span>
              </div>
            ))}
            {sortedCountries.length === 0 && (
              <div className="no-data">No country data available</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Leaderboard;